import QuickReplyButtonsBlock from './QuickReplyButtonsBlock';
export default QuickReplyButtonsBlock;
